import { isTimestampAfterCurrentDate } from "../helpers/datetimeHelper";
export function validEarningLoyalityRoles(LoyalityRoles, storeZone) {
  let validLoyalityRoles = LoyalityRoles.filter(
    pt => !pt.Disable && isTimestampAfterCurrentDate(pt.ExpiredDate, storeZone)
  );
  return validLoyalityRoles;
}
